export const tourGuideSteps = [
    {
        selector: "#Channel-Metrics-column-0",
        content:
            "The number of messages that were received within the time range."
    },
    {
        selector: "#Channel-Metrics-column-1",
        content:
            "The maximum message queue amount within the time range."
    },
    {
        selector: "#Channel-Metrics-column-2",
        content:
            "The number of messages that were filtered within the time range."
    },
    {
        selector: "#Channel-Metrics-column-3",
        content:
            "The number of messages that errored within the time range."
    },
    {
        selector: "#Channel-Metrics-column-4",
        content:
            "The number of messages that were successfully transformed and sent within the time range."
    },
    {
        selector: "#Channel-Metrics-column-5",
        content:
            "The average total time it took for a message to be processed through this channel, from source starting to postprocessor or the very last destination queued message to finish, within the time range."
    },
    {
        selector: "#Channel-Metrics-column-6",
        content:
            "The average time it took between the first destination starting and the postprocessor or final destination queued message to finish within the time range."
    },
    {
        selector: "#Channel-Metrics-column-7",
        content:
            "The average time it took for a message to be processed through this channel, from source starting to postprocessor finishing (not counting destination queues) within the time range."
    },
    {
        selector: "#Channel-Metrics-column-8",
        content:
            "The average raw message size of messages within the time range."
    },
    {
        selector: "#Channel-Metrics-column-9",
        content:
            "The average attachment size of messages within the time range."
    },
    {
        selector: "#Connectors-column-0",
        content:
            "The connector id (0 is always the source connector)."
    },
    {
        selector: "#Connectors-column-1",
        content:
            "The connector name (this value is user defined)."
    },
    {
        selector: "#Connectors-column-2",
        content:
            "The connector type (Mirth Connect provides this type)."
    },
    {
        selector: "#Connectors-column-3",
        content:
            "The number of messages that were processed by this connector within the time range."
    },
    {
        selector: "#Connectors-column-4",
        content:
            "The average time it took between this destination sending a message and receiving a response. Note: this does not include the connector's transformer, filter, or the connector processing logic itself, only how long it took to get a response back from the message recipient."
    },
  ];